export const GROUP_ID_LENGTH = 36;
export const POTENCIES = [
  "3 kVA",
  "6 kVA",
  "9 kVA",
  "12 kVA",
  "15 kVA",
  "18 kVA",
  "24 kVA",
  "30 kVA",
  "36 kVA",
  "42 kVA",
  "48 kVA",
  "54 kVA",
  "60 kVA",
  "66 kVA",
  "72 kVA",
  "78 kVA",
  "84 kVA",
  "90 kVA",
  "96 kVA",
  "102 kVA",
  "108 kVA",
  "120 kVA",
  "132 kVA",
  "144 kVA",
  "156 kVA",
  "168 kVA",
  "180 kVA",
  "192 kVA",
  "204 kVA",
  "216 kVA",
  "228 kVA",
  "240 kVA",
];
